<template>
  <div class="buy-data">
    <div class="buy-data__title">Ingresa la cuenta con la que te deseas registrar</div>
    <div class="buy-data__cont-input-single"><InputForm placeholder="E-mail" type="email" v-model="form.email" /></div>
    <div class="buy-data__cont-input-dual">
      <div class="buy-data__cont-input-dual__cont-input">
        <InputForm placeholder="Contraseña" type="password" v-model="form.email" />
      </div>
      <div class="buy-data__cont-input-dual__cont-input">
        <InputForm placeholder="Confirmar Contraseña" type="password" v-model="form.email" />
      </div>
    </div>
    <div class="alert-gray">
      Ya existe una cuenta Premium ligada a este correo <span class="alert-gray__email">rod.lopez@gmail.com</span>
      <br />
      <span class="alert-gray__question">¿Deseas Iniciar Sesión?</span>
    </div>
    <div class="buy-data__cont-check-terms">
      <label class="checkbox">
        <input type="checkbox" />
        <span class="label-term">Acepto los</span>
        <RouterLink to="/terms" target="_blank" class="label-term-black-buy"
          >&nbsp;&nbsp;Términos y condiciones</RouterLink
        >
      </label>
    </div>
    <div class="buy-data__cont-btn"><div class="buy-data__cont-btn__btn">Siguiente</div></div>
    <div class="buy-data__leyend-login">
      Ya tengo una cuenta <span class="buy-data__leyend-login__login">Iniciar sesión</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Data',
  components: { InputForm: () => import('@/components/Sections/Buy/InputForm') },
  data() {
    return {
      form: {
        user: '',
        password: '',
        email: '',
      },
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style scoped>
.label-term-black-buy {
  font-family: 'Avenir-Bold';
  color: #494a4b;
  text-decoration: underline;
  margin-left: 4px;
}
.buy-data .checkbox {
  width: 100%;
  font-size: 13px;
  text-align: start;
  display: inline-flex;
  justify-content: left;
  margin-top: 4px;
  align-content: left;
  align-items: left;
}
.buy-data .checkbox > input {
  width: 18px;
  height: 18px;
  margin-top: -2px;
}
</style>
<style lang="scss" scoped>
.alert-gray {
  width: 523px;
  height: 56px;
  border-radius: 8px;
  background-color: #f4f4f4;
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  margin-top: 17px;
  padding-top: 8px;
  color: #132839;
  font-family: 'Avenir-Medium';
  @media screen and (max-width: 915px) {
    width: 100%;
    font-size: 12px;
  }
  @media screen and (max-width: 768px) {
    margin-top: 55px;
  }
  @media screen and (max-width: 480px) {
    font-size: 10px;
    padding-top: 11px;
  }
  @media screen and (max-width: 400px) {
    font-size: 9px;
    padding-top: 13px;
  }
  @media screen and (max-width: 360px) {
    font-size: 8px;
    padding-top: 15px;
  }
  &__email {
    font-family: 'Avenir-Bold';
  }
  &__question {
    font-family: 'Avenir-Bold';
    text-decoration: underline;
    cursor: pointer;
  }
}
.buy-data {
  width: 524px;
  height: 400px;
  margin: 0 auto;
  margin-top: 54px;
  @media screen and (max-width: 915px) {
    width: 92%;
  }
  @media screen and (max-width: 768px) {
    margin-top: 34px;
    width: 67%;
  }
  @media screen and (max-width: 670px) {
    width: 70%;
  }
  @media screen and (max-width: 640px) {
    width: 76%;
  }
  @media screen and (max-width: 590px) {
    width: 82%;
  }
  @media screen and (max-width: 380px) {
    width: 88%;
  }
  &__title {
    font-family: 'Avenir-Medium';
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: center;
    color: #132839;
    margin-bottom: 38px;
    @media screen and (max-width: 915px) {
      font-size: 18px;
    }
    @media screen and (max-width: 768px) {
      font-size: 20px;
      margin-bottom: 24px;
    }
    @media screen and (max-width: 590px) {
      font-size: 19px;
    }
    @media screen and (max-width: 530px) {
      font-size: 18px;
    }
  }
  &__cont-input-single {
    width: 100%;
    height: 44px;
  }
  &__cont-input-dual {
    width: 100%;
    height: 44px;
    margin-top: 20px;
    display: inline-flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      display: inline-block;
    }
    &__cont-input {
      width: 48%;
      height: 44px;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
  &__cont-check-terms {
    width: 100%;
    height: 18px;
    display: inline-flex;
    justify-content: left;
    margin-top: 16px;
  }
  &__cont-btn {
    width: 100%;
    height: 48px;
    margin-top: 46px;
    display: inline-flex;
    justify-content: center;
    &__btn {
      width: 315px;
      height: 48px;
      background-color: #4a88ff;
      border-radius: 50px;
      font-size: 20px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 50px;
      letter-spacing: normal;
      text-align: center;
      font-family: 'Avenir-Medium';
      color: #fff;
      @media screen and (max-width: 480px) {
        width: 100%;
      }
    }
  }
  &__leyend-login {
    width: 100%;
    height: 48px;
    margin-top: 26px;
    display: inline-flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    font-family: 'Avenir-Regular';
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.87;
    letter-spacing: normal;
    text-align: left;
    color: #132839;
    @media screen and (max-width: 768px) {
      margin-top: 36px;
    }
    &__login {
      font-family: 'Avenir-Bold';
      text-decoration: underline;
      margin-left: 4px;
    }
  }
}
</style>
